import React, {useEffect, useRef, useState} from 'react';
import {Editor} from '@tinymce/tinymce-react';
import {Liquid} from "liquidjs";

const ReadOnlyContent = ({editorContent}) => {
  const placeholders = {
    //test: "ABC"
  }
  const engine = new Liquid()
  let html = editorContent;
  try {
    //const tpl = engine.parse(html)
    html = engine.parseAndRenderSync(html, placeholders)
  } catch (ex) {
    console.error(ex, "placeholders", placeholders, html)
  }

  return <div className={"react-page-editor-text"} dangerouslySetInnerHTML={{__html: html}}/>
}

const TinyMceCellPlugin = () => {
  // const [editor] = useState(() => withReact(createEditor()))

  return {
    Renderer: (props) => {
      console.log("Renderer", props)

      if (props.readOnly) {
        return <ReadOnlyContent editorContent={props.data?.editorContent}/>
      }

      return <div className={"react-page-editor-text"}>
        <Editor
          init={{
            inline: true,
            // toolbar_persist: true,
            // toolbar_mode: 'floating',
            // fixed_toolbar_container_target: props.pluginConfig.toolbar_element,
          }}
          initialValue={props.data?.editorContent}
          onEditorChange={(editorContent) => {
            console.log("Content change", {editorContent})
            props.onChange({editorContent})
          }}
        />
      </div>
    },

    id: 'tinymce-cell-plugin',
    title: 'Text Editor',
    description: 'Text editor',
    version: 1,
    allowClickInside: true,
    toolbar_element: document.createElement('div'),
    controls: {
      type: 'custom',
      allowClickInside: true,
      Component: (props) => {
        const ref = useRef(null)
        useEffect(() => {
          console.log("REFF", ref.current)
          ref.current.append(props.pluginConfig.toolbar_element)
        }, [ref.current])

        return <div ref={ref}/>
      },
    },
    // editorRef: "ABC",
    // controls: {
    //   type: 'autoform',
    //   schema: {
    //     properties: {
    //       url: {
    //         type: 'string',
    //         default: 'https://flave.at',
    //       },
    //     },
    //     required: ['url'],
    //   },
    // },
  }
}

export default TinyMceCellPlugin